﻿import { ResultatValg, SET_VISNING, ResultatActionTypes } from './Types';
import { ValgStateActionTypes } from '../Valg/Types';

const initialState: ResultatValg = {
    visStudieforberedendeBa: false,
    visYrkesfagBb: false,
    visAarCa: false,
    visAarCb: false,
    visAarCc: false,
    visAarCd: false,
    visAarCe: false,
    visProgramDa: false,
    visProgramDb: false,
    visProgramDc: false,
    visProgramDd: false,
    visProgramDdVg3: false,
    visProgramDe: false,
    visUtstyrsstipendEa: false,
    visUtstyrsstipendEb: false,
    visUtstyrsstipendEc: false,
    visUtstyrsstipendEd: false,
    visUtstyrsstipendEe: false,
    visGenerellFeil: false,
};

export function resultatReducer(
    state: ResultatValg = initialState,
    action: ValgStateActionTypes | ResultatActionTypes,
): ResultatValg {
    switch (action.type) {
        case SET_VISNING: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
}
